export default __webpack_public_path__ + "static/media/nodejs.9094a233.svg";